export default __webpack_public_path__ + "img/favicon.png";